import React, { useRef, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Dropdown, Menu, Button } from "antd";
import { Link } from "react-router-dom";
import {
    detailsVacApp,
    updateVacApp,
} from "../actions/vaccineAppointmentActions";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Layout from "../core/Layout";
import { useUpdateAppointment, useVacAppDetails } from "./api/app";
import showToast from "../utils/toast";

const suggestionsList = [
    "Psychoeducation",
    "CBT",
    "DBT",
    "ERP",
    "CDT",
    "MET",
    "RPT",
    "IPSRT",
    "Relaxation Training",
    "Mindfulness",

    "Family Therapy",
    "Psychotherapy and counselling",
    "social skill training",
    "Pharmacotherapy",
    "Regular followUps",
];

const Psychodiagnostic = () => {
    const [formData, setFormData] = useState({
        name: "",
        age: "",
        motherTongue: "",
        maritalStatus: "",
        education: "",
        date: "",
        address: "",
        refByDr: "",
        reasonForReferral: "",
        chiefComplaints: [],
        NoOfEpisodes: "",
        duration: "",
        blotTest: "",
        precipitation: "",
        informant: "",
        occupation: "",
        onset: "",
        course: "",
        progression: "",
        backInformation: "",
        backgroundInfo: {
            personalHistory: {
                birth: "",
                developmentalHistory: "",
                childhoodHistory: "",
                educationalHistory: "",
                occupationalHistory: "",
                sexualHistory: "",
                menstrualHistory: "",
                substanceHistory: "",
                maritalHistory: "",
            },
            premorbidPersonality: {
                self: [
                    {
                        question:
                            "How does the patient describe himself or herself?",
                        answer: "",
                    },
                    {
                        question:
                            "What are their strengths and ability to plan ahead?",
                        answer: "",
                    },
                    {
                        question:
                            "What is their resilience in the face of adversity?",
                        answer: "",
                    },
                    {
                        question: "What are their hopes and ambitions?",
                        answer: "",
                    },
                ],
                relations: [
                    {
                        question: "Does he/she prefer company or solitude?",
                        answer: "",
                    },
                    {
                        question: "Is he/she shy or makes friends easily?",
                        answer: "",
                    },
                    {
                        question: "Are the relationships close or lasting?",
                        answer: "",
                    },
                    {
                        question: "How does he/she handle others' mistakes?",
                        answer: "",
                    },
                ],
                workAndLeisure: [
                    {
                        question:
                            "Relation with workmates or superiors, hobbies, or interests?",
                        answer: "",
                    },
                    { question: "What is their mood like?", answer: "" },
                    { question: "How changeable is it?", answer: "" },
                    {
                        question:
                            "Can he/she express feelings of love, anger, frustration, or sadness?",
                        answer: "",
                    },
                ],
                character: [
                    {
                        question:
                            "Is he/she reserved, timid, self-conscious, resentful, or jealous?",
                        answer: "",
                    },
                    {
                        question:
                            "Is he/she irritable, selfish, or self-centered?",
                        answer: "",
                    },
                ],
                attitudesAndStandards: [
                    {
                        question:
                            "Attitudes to health and illness as well as religious and moral standards.",
                        answer: "",
                    },
                ],
                habits: [
                    {
                        question: "Use of tobacco, alcohol, or drugs?",
                        answer: "",
                    },
                    {
                        question: "Comment on food and sleep patterns.",
                        answer: "",
                    },
                ],
            },
        },
        behaviouralInfo: {
            behaviouralEntry: "",
            generalAppearanceAndBehaviour: {
                "Physical Appearance": "",
                "Estimate Of Age": "",
                "Body Built": "",
                "Touch With Surroundings": "",
                "Eye Contact": "",
                Dress: "",
                "Facial Expression": "",
                Posture: "",
                "Attitude Towards Examiner": "",
            },
            orientation: {
                time: "",
                place: "",
                person: "",
                senseOfPassageOfTime: "",
            },
            motorBehaviour: {
                psychomotorActivity: "", // To store a single selected option
                disturbances: [], // To store multiple selected options
            },
            levelOfConsciousness: {
                mediate: "", // Stores the selected option
                attention: "",
            },
            speech: {
                intensity: "",
                reactionTime: "",
                speed: "",
                ease: "",
                relevance: "",
                coherant: "",
                goalDirected: "",
                deviation: "",
            },
            memory: {
                immediate: "",
                recent: "",
                remote: "",
            },
            intelligences: {
                fundOfInformation: "",
                calculations: "",
                abstractReasoning: "",
            },
            judgement: {
                social: "",
                personal: "",
                test: "",
            },
            thought: {
                stream: [],
                form: [],
                possession: [],
                content: [],
                perceptual: [],
            },
            thoughtDetails: {
                stream: "", // single extra input field
                form: "",
                possession: "",
                content: "",
                perceptual: "",
            },
        },

        mood: "",
        moodInput: "",
        additionalInfo1: "",
        additionalInfo2: "",
        toolsUsed: "",
        testFinding: "",
        interpretations: "",
        impression: "",
        suggestions: [],
        date: new Date(),
    });
    const [existingData, setExistingData] = useState(null);
    const [toolsOptions, setToolOptions] = useState([]);
    const [blotTest, setBlotTest] = useState(0);
    const updateAppData = useUpdateAppointment();
    const dispatch = useDispatch();
    const { id } = useParams();

    const navigate = useNavigate();
    // Handle input change for text and number fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    // Handle dropdown change for onset, course, and progression
    const handleDropdownChange = (field, value) => {
        setFormData((prevData) => ({ ...prevData, [field]: value }));
    };

    const handleThoughtDetailsChange = (key, value) => {
        setFormData((prevData) => ({
            ...prevData,
            behaviouralInfo: {
                ...prevData.behaviouralInfo,
                thoughtDetails: {
                    ...prevData.behaviouralInfo.thoughtDetails,
                    [key]: value,
                },
            },
        }));
    };
    // Handle adding chief complaints with duration
    const addChiefComplaint = () => {
        setFormData((prevData) => ({
            ...prevData,
            chiefComplaints: [
                ...prevData.chiefComplaints,
                { complaint: "" }, // Default duration
            ],
        }));
    };

    const handleThoughtChange = (key, option, checked) => {
        setFormData((prevData) => {
            const updatedThought = { ...prevData.behaviouralInfo.thought };
            if (checked) {
                updatedThought[key] = [...updatedThought[key], option]; // Add selected option
            } else {
                updatedThought[key] = updatedThought[key].filter(
                    (item) => item !== option
                ); // Remove unselected option
            }

            return {
                ...prevData,
                behaviouralInfo: {
                    ...prevData.behaviouralInfo,
                    thought: updatedThought,
                },
            };
        });
    };

    const handleSugestion = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevFormData) => {
            if (type === "checkbox") {
                if (checked) {
                    return {
                        ...prevFormData,
                        [name]: [...prevFormData[name], value],
                    };
                } else {
                    return {
                        ...prevFormData,
                        [name]: prevFormData[name].filter(
                            (item) => item !== value
                        ),
                    };
                }
            }

            return {
                ...prevFormData,
                [name]: value, // Update text input value
            };
        });
    };
    const moveComplaint = (fromIndex, toIndex) => {
        const updatedComplaints = [...formData.chiefComplaints];
        const [movedComplaint] = updatedComplaints.splice(fromIndex, 1);
        updatedComplaints.splice(toIndex, 0, movedComplaint);
        setFormData({ ...formData, chiefComplaints: updatedComplaints });
    };

    const handleBehaviouralDropdown = (category, field, value) => {
        setFormData((prevState) => ({
            ...prevState,
            behaviouralInfo: {
                ...prevState.behaviouralInfo,
                [category]: {
                    ...prevState.behaviouralInfo[category],
                    [field]: value,
                },
            },
        }));
    };
    // Handle change for each chief complaint and duration
    const handleChiefComplaintChange = (index, field, value) => {
        const updatedComplaints = formData.chiefComplaints.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setFormData((prevData) => ({
            ...prevData,
            chiefComplaints: updatedComplaints,
        }));
    };

    const handleBehaviouralObservation = (
        category,
        subCategory,
        subSubCategory
    ) => {
        setFormData((prevData) => {
            const updatedBehaviourInformation = [...prevData.behaviouralInfo];
            updatedBehaviourInformation.push({
                category,
                subCategory,
                subSubCategory,
            });
            return {
                ...prevData,
                behaviouralInfo: updatedBehaviourInformation,
            };
        });
    };

    const handleAdditionalInfoChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            additionalInfo1: e.target.value,
        }));
    };
    const handleAdditionalInfoChange2 = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            additionalInfo2: e.target.value,
        }));
    };

    const handleDisturbancesChange = (value) => {
        setFormData((prevData) => {
            const isAlreadySelected =
                prevData.behaviouralInfo.motorBehaviour.disturbances.includes(
                    value
                );
            const updatedDisturbances = isAlreadySelected
                ? prevData.behaviouralInfo.motorBehaviour.disturbances.filter(
                      (item) => item !== value
                  )
                : [
                      ...prevData.behaviouralInfo.motorBehaviour.disturbances,
                      value,
                  ];

            return {
                ...prevData,
                behaviouralInfo: {
                    ...prevData.behaviouralInfo,
                    motorBehaviour: {
                        ...prevData.behaviouralInfo.motorBehaviour,
                        disturbances: updatedDisturbances,
                    },
                },
            };
        });
    };

    const handlePsychomotorActivityChange = (value) => {
        setFormData((prevData) => ({
            ...prevData,
            behaviouralInfo: {
                ...prevData.behaviouralInfo,
                motorBehaviour: {
                    ...prevData.behaviouralInfo.motorBehaviour,
                    psychomotorActivity: value,
                },
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const updatedFormData = {
            ...formData,
            toolsUsed: toolsOptions
        };

        updateAppData.mutate({
            _id: appointment?._id,
            psychodiagnostic: updatedFormData,
        });

        // Clear localStorage after successful submit
        localStorage.removeItem(`psycho_tools_${id}`);

        dispatch(detailsVacApp(id));
        showToast("form is submittted");
    };

    const { data, refetch } = useVacAppDetails(id);
    const appointment = data?.appointment || null;

    // Function to load scores from localStorage
    const loadScoresFromLocalStorage = () => {
        const localStorageKey = `psycho_tools_${id}`;
        const savedScores = localStorage.getItem(localStorageKey);

        let tools = [
            {
                tool: "HAM-A",
                score: appointment?.hamA ? appointment.hamA.score : null,
            },
            {
                tool: "HAM-D",
                score: appointment?.hamD ? appointment.hamD.score : null,
            },
            {
                tool: "YMRS",
                score: appointment?.ymrs ? appointment.ymrs.score : null,
            },
            {
                tool: "CDRS",
                score: appointment?.cdrs ? appointment.cdrs.score : null,
            },
            {
                tool: "PANSS",
                score: appointment?.panss ? appointment.panss.score : null,
            },
            {
                tool: "YBOCS",
                score: appointment?.ybocs ? appointment?.ybocs.score : null,
            },
            {
                tool: "BDI",
                score: appointment?.bdi ? appointment?.bdi.score : null,
            },
            {
                tool: "CYBCOS",
                score: appointment?.cybcos ? appointment?.cybcos.score : null,
            },
            {
                tool: "ISAA",
                score: appointment?.isaa ? appointment?.isaa.score : null,
            },
            {
                tool: "Brief Psychiatric Rating Scale",
                score: appointment?.psychiatric
                    ? appointment?.psychiatric.score
                    : null,
            },
            {
                tool: "Rorschach Ink Blot Test",
                score: formData.blotTest === "1" ? "Done" : null,
            },
        ];

        // Override with localStorage scores if available
        if (savedScores) {
            try {
                const parsedScores = JSON.parse(savedScores);
                tools = tools.map(tool => {
                    const localScore = parsedScores[tool.tool];
                    return {
                        ...tool,
                        score: localScore !== undefined ? localScore : tool.score
                    };
                });
            } catch (error) {
                console.error('Error parsing localStorage scores:', error);
            }
        }

        return tools.filter((tool) => tool.score !== null);
    };

    useEffect(() => {
        setExistingData(
            appointment?.psychodiagnostic ? appointment?.psychodiagnostic : null
        );

        setToolOptions(loadScoresFromLocalStorage());
    }, [appointment, id, formData.blotTest]);

    // Listen for storage changes from other tabs/windows
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === `psycho_tools_${id}`) {
                setToolOptions(loadScoresFromLocalStorage());
            }
        };

        window.addEventListener('storage', handleStorageChange);

        // Also poll localStorage every 2 seconds (for same-tab updates)
        const intervalId = setInterval(() => {
            setToolOptions(loadScoresFromLocalStorage());
        }, 2000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(intervalId);
        };
    }, [appointment, id, formData.blotTest]);

    useEffect(() => {
        refetch();
        if (existingData) {
            setFormData((prevData) => ({
                ...prevData,
                ...existingData,
                behaviouralInfo: {
                    ...prevData.behaviouralInfo,
                    ...existingData.behaviouralInfo,
                },
                backgroundInfo: {
                    ...prevData.backgroundInfo,
                    ...existingData.backgroundInfo,
                    personalHistory: {
                        ...prevData.backgroundInfo.personalHistory,
                        ...existingData.backgroundInfo?.personalHistory,
                    },
                    premorbidPersonality: {
                        ...prevData.backgroundInfo.premorbidPersonality,
                        ...existingData.backgroundInfo?.premorbidPersonality,
                    },
                },
            }));
        }
    }, [existingData]);

    // Clear localStorage on page refresh or component unmount
    useEffect(() => {
        const localStorageKey = `psycho_tools_${id}`;

        const handleBeforeUnload = () => {
            localStorage.removeItem(localStorageKey);
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            // Also clear on component unmount (navigation away)
            localStorage.removeItem(localStorageKey);
        };
    }, [id]);

    const deleteChiefComplaint = (index) => {
        setFormData((prevData) => ({
            ...prevData,
            chiefComplaints: prevData.chiefComplaints.filter(
                (_, i) => i !== index
            ),
        }));
    };

    const handleBackgroundInfoChange = (section, field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            backgroundInfo: {
                ...prevData.backgroundInfo,
                [section]: {
                    ...prevData.backgroundInfo[section],
                    [field]: value,
                },
            },
        }));
    };

    const handleDragEnd = (result) => {
        const { destination, source } = result;

        if (!destination) return;

        if (destination.index === source.index) return;

        const updatedComplaints = [...formData.chiefComplaints];
        const [movedComplaint] = updatedComplaints.splice(source.index, 1);
        updatedComplaints.splice(destination.index, 0, movedComplaint);

        setFormData({ ...formData, chiefComplaints: updatedComplaints });
    };

    const handleBehavouralInfoChange = (section, field, value) => {
        setFormData((prevData) => {
            if (section) {
                // Case: update inside a section object
                return {
                    ...prevData,
                    behaviouralInfo: {
                        ...prevData.behaviouralInfo,
                        [section]: {
                            ...prevData.behaviouralInfo[section],
                            [field]: value,
                        },
                    },
                };
            } else {
                return {
                    ...prevData,
                    behaviouralInfo: {
                        ...prevData.behaviouralInfo,
                        [field]: value,
                    },
                };
            }
        });
    };

    const handlePremorbidChange = (section, index, value) => {
        setFormData((prevData) => {
            const updatedSelf = [
                ...prevData.backgroundInfo.premorbidPersonality[section],
            ];
            updatedSelf[index].answer = value;
            return {
                ...prevData,
                backgroundInfo: {
                    ...prevData.backgroundInfo,
                    premorbidPersonality: {
                        ...prevData.backgroundInfo.premorbidPersonality,
                        [section]: updatedSelf,
                    },
                },
            };
        });
    };

    const calculateAge = (date) => {
        if (!date || date === "Invalid date") return 0;

        const birthMoment = dayjs(date);
        const today = dayjs();

        return today.diff(birthMoment, "years"); // Calculate the difference in years
    };

    return (
        <Layout>
            <>
                <div
                    style={{
                        position: "fixed",
                        top: "50px",
                        backgroundColor: "white",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            display: "flex ",
                            justifyContent: "center",
                            alignContent: "center",
                            flexDirection: "row-reverse",
                        }}
                    >
                        <button
                            style={styles.viewButton}
                            onClick={() =>
                                navigate(
                                    `/psychodiagnosticreport/${appointment?._id}`
                                )
                            }
                        >
                            View{" "}
                        </button>
                        <button
                            style={styles.viewButton}
                            onClick={() => navigate("/patient-app-details")}
                        >
                            Back
                        </button>
                    </div>
                </div>

                <form style={styles.form} onSubmit={handleSubmit}>
                    <h3 style={styles.formHeader}>Psychodiagnostic Report</h3>
                    {appointment && appointment.patient && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <p className="m-0">
                                <p className="m-0">
                                    Name:{" "}
                                    <span>
                                        {appointment.patient.firstName.toUpperCase() +
                                            " " +
                                            appointment.patient.lastName.toUpperCase()}
                                    </span>
                                </p>

                                <p>
                                    {" "}
                                    Age:{" "}
                                    <span>
                                        {appointment.patient.age
                                            ? `${appointment.patient.age} years`
                                            : appointment.patient.birthDate &&
                                              appointment.patient.birthDate !==
                                                  "Invalid date"
                                            ? `${calculateAge(
                                                  appointment.patient.birthDate
                                              )} years`
                                            : "0 years"}
                                    </span>
                                </p>
                            </p>
                            <p className="m-0">
                                <p className="m-0">
                                    Date:{" "}
                                    {dayjs(Date.now()).format("DD-MM-YYYY")}
                                </p>
                                <p className="m-0">
                                    Address: {appointment.patient.address}
                                </p>
                            </p>
                        </div>
                    )}
                    <label style={styles.labels}>
                        Mother Tongue:
                        <input
                            type="text"
                            name="motherTongue"
                            value={formData.motherTongue}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>
                    <label style={styles.labels}>
                        Marital Status:
                        <input
                            type="text"
                            name="maritalStatus"
                            value={formData.maritalStatus}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>
                    <label style={styles.labels}>
                        Education:
                        <input
                            type="text"
                            name="education"
                            value={formData.education}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>

                    <label style={styles.labels}>
                        Refer By Doctor:
                        <input
                            type="text"
                            name="refByDr"
                            value={formData.refByDr}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>

                    <label style={styles.labels}>
                        Reason For Referral:
                        <input
                            type="text"
                            name="reasonForReferral"
                            value={formData.reasonForReferral}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>
                    <label style={styles.labels}>
                        Informant:
                        <input
                            type="text"
                            name="informant"
                            value={formData.informant}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>
                    <label style={styles.labels}>
                        Ocuupation:
                        <input
                            type="text"
                            name="occupation"
                            value={formData.occupation}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>
                    <div>
                        <h4>Chief Complaints</h4>

                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="complaints">
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        style={styles.droppableArea}
                                    >
                                        {formData.chiefComplaints.map(
                                            (complaint, index) => {
                                                // Split the duration into value and unit
                                                const [value, unit] =
                                                    complaint.duration
                                                        ? complaint.duration.split(
                                                              " "
                                                          )
                                                        : ["", "days"];

                                                return (
                                                    <Draggable
                                                        key={index}
                                                        draggableId={`complaint-${index}`}
                                                        index={index}
                                                    >
                                                        {(provided) => (
                                                            <div
                                                                ref={
                                                                    provided.innerRef
                                                                }
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    ...styles.chiefComplaintGroup,
                                                                    ...provided
                                                                        .draggableProps
                                                                        .style,
                                                                    display:
                                                                        "flex",
                                                                    margin: "3px",
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    value={
                                                                        complaint.complaint
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handleChiefComplaintChange(
                                                                            index,
                                                                            "complaint",
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    placeholder="Chief Complaint"
                                                                    style={
                                                                        styles.input
                                                                    }
                                                                />

                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        deleteChiefComplaint(
                                                                            index
                                                                        )
                                                                    }
                                                                    style={
                                                                        styles.deleteButton
                                                                    }
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                );
                                            }
                                        )}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                        <label style={{ ...styles.labels, margin: "2px" }}>
                            No Of Episodes
                            <input
                                type="text"
                                name="NoOfEpisodes"
                                value={formData.NoOfEpisodes}
                                onChange={handleChange}
                                style={styles.input}
                            />
                        </label>
                        <label style={{ ...styles.labels, margin: "2px" }}>
                            Duration
                            <input
                                type="text"
                                name="duration"
                                value={formData.duration}
                                onChange={handleChange}
                                style={styles.input}
                            />
                        </label>
                        <button
                            type="button"
                            onClick={addChiefComplaint}
                            style={styles.addButton}
                        >
                            Add Complaint
                        </button>
                    </div>

                    <label style={styles.labels}>
                        Precipitation:
                        <input
                            type="text"
                            name="precipitation"
                            value={formData.precipitation}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>

                    <label style={styles.labels}>
                        Onset:
                        <select
                            name="onset"
                            value={formData.onset}
                            onChange={(e) =>
                                handleDropdownChange("onset", e.target.value)
                            }
                            style={styles.select}
                        >
                            <option value="">Select Onset</option>
                            <option value="acute">Acute</option>
                            <option value="subacute">Subacute</option>
                            <option value="abrupt">Abrupt</option>
                            <option value="insidious">Insidious</option>
                        </select>
                    </label>

                    <label style={styles.labels}>
                        Course:
                        <select
                            name="course"
                            value={formData.course}
                            onChange={(e) =>
                                handleDropdownChange("course", e.target.value)
                            }
                            style={styles.select}
                        >
                            <option value="">Select Course</option>
                            <option value="continuous">Continuous</option>
                            <option value="fluctuating">Fluctuating</option>
                            <option value="episodic">Episodic</option>
                        </select>
                    </label>

                    <label style={styles.labels}>
                        Progression:
                        <select
                            name="progression"
                            value={formData.progression}
                            onChange={(e) =>
                                handleDropdownChange(
                                    "progression",
                                    e.target.value
                                )
                            }
                            style={styles.select}
                        >
                            <option value="">Select Progression</option>
                            <option value="deteriorating">Deteriorating</option>
                            <option value="constant">Constant</option>
                            <option value="improving">Improving</option>
                        </select>
                    </label>
                    <label style={styles.labels}>
                        BackgroundInfo
                        <textarea
                            type="text"
                            name="backInformation"
                            value={formData.backInformation}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>
                    <h4>Personal History</h4>
                    {Object.keys(formData.backgroundInfo.personalHistory).map(
                        (key) => (
                            <label key={key} style={styles.labels}>
                                {key.replace(/([A-Z])/g, " $1").toUpperCase()}:
                                {formData.backgroundInfo.personalHistory[
                                    key
                                ] !== "Nil contributory" && (
                                    <input
                                        type="text"
                                        name={key}
                                        value={
                                            formData.backgroundInfo
                                                .personalHistory[key]
                                        }
                                        onChange={(e) =>
                                            handleBackgroundInfoChange(
                                                "personalHistory",
                                                key,
                                                e.target.value
                                            )
                                        }
                                        placeholder="Enter"
                                        style={{
                                            flex: 1,
                                            padding: "8px",
                                            marginLeft: "5px",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                        }}
                                    />
                                )}
                                <label style={{ cursor: "pointer" }}>
                                    <input
                                        type="checkbox"
                                        className="ml-3"
                                        checked={
                                            formData.backgroundInfo
                                                .personalHistory[key] ===
                                            "Nil contributory"
                                        }
                                        onChange={(e) =>
                                            handleBackgroundInfoChange(
                                                "personalHistory",
                                                key,
                                                e.target.checked
                                                    ? "Nil contributory"
                                                    : ""
                                            )
                                        }
                                    />
                                    <span className="ml-3">
                                        Nil contributory
                                    </span>
                                </label>
                            </label>
                        )
                    )}

                    {/* Premorbid Personality Inputs */}
                    <h4>Premorbid Personality</h4>
                    {Object.keys(
                        formData.backgroundInfo.premorbidPersonality
                    ).map((section) => (
                        <div key={section}>
                            <h5 style={{ fontSize: "18px", fontWeight: "500" }}>
                                {section
                                    .replace(/([A-Z])/g, " $1")
                                    .toUpperCase()}
                            </h5>
                            {formData.backgroundInfo.premorbidPersonality[
                                section
                            ].map((item, index) => (
                                <div
                                    key={index}
                                    style={styles.premorbidSection}
                                >
                                    <label style={styles.labels}>
                                        {item.question}
                                    </label>

                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        {/* Checkbox for "Nil contributory" */}

                                        <input
                                            type="text"
                                            value={item.answer}
                                            onChange={(e) =>
                                                handlePremorbidChange(
                                                    section,
                                                    index,
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Enter answer"
                                            style={styles.input}
                                        />
                                        <label style={{ cursor: "pointer" }}>
                                            <input
                                                type="checkbox"
                                                checked={
                                                    item.answer ===
                                                    "Nil contributory"
                                                }
                                                onChange={(e) =>
                                                    handlePremorbidChange(
                                                        section,
                                                        index,
                                                        e.target.checked
                                                            ? "Nil contributory"
                                                            : ""
                                                    )
                                                }
                                            />
                                            <span style={{ marginLeft: 4 }}>
                                                Nil contributory
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}

                    <fieldset
                        style={{
                            border: "1px solid #ccc",
                            padding: "1rem",
                            margin: "1rem 0",
                        }}
                    >
                        <legend>Mental Status Examination</legend>
                        <h5 style={{ marginTop: "5px" }}>Behaviour Info </h5>
                        <div style={styles.categorySection}>
                            <textarea
                                name="behaviouralEntry" // 👈 input name
                                placeholder="behavioural Info"
                                value={
                                    formData.behaviouralInfo.behaviouralEntry ||
                                    ""
                                }
                                onChange={(e) =>
                                    handleBehavouralInfoChange(
                                        null,
                                        "behaviouralEntry",
                                        e.target.value
                                    )
                                }
                                style={{
                                    width: "300px",
                                    padding: "6px",
                                }}
                            />
                        </div>

                        <div className="mb-4">
                            General Appearance and Behaviour
                        </div>
                        {Object.entries({
                            "Physical Appearance": [
                                "Patient is Kempt and tidy",
                                "Patient is Overly Made-Up",
                                "Patient is Unkempt and Untidy",
                                "Patient appears Sickly",
                                "Patient is Perplexed",
                            ],
                            "Estimate Of Age": [
                                "Patent seems Appropriate of age",
                                "Patient Seems Younger",
                                "Patient Seems Older",
                            ],
                            "Body Built": [
                                "Lean  Built",
                                "Average  Built",
                                "Muscular  Built ",
                                "Obese Built",
                            ],
                            "Touch With Surroundings": [
                                "Touch With Surroundings",
                                "Not Touch With Surroundings",
                            ],
                            "Eye Contact": [
                                "Eye Contact is Maintained",
                                "Eye Contact is Partial",
                                "Eye Contact is Shifting Gaze",
                                "Eye Contact is Absent",
                            ],
                            Dress: [
                                "Dress is Appropriate",
                                "Dress is Inappropriate",
                            ],
                            "Facial Expression": [
                                "Facial Expression Appropriate",
                                "Facial Expression shows Anger",
                                "Facial Expression shows Disgust",
                                "Facial Expression shows Frown",
                            ],
                            Posture: [
                                "Normal Posture",
                                "Relaxed Posture",
                                "Stiff Posture",
                                "Slouched Posture",
                                "Upright Posture",
                                "Odd Posture",
                                "Stooped Posture",
                                "Tense Posture",
                                "Mannerism ",
                                "flexibility",
                            ],
                            "Attitude Towards Examiner": [
                                "Patient is Cooperative",
                                "Patient is Defensive",
                                "Patient is Exhibitionistic",
                                "Patient is Seductive",
                                "Patient is Hostile",
                                "Patient is Playful",
                                "Patient is Evasive",
                                "Patient is Guarded",
                                "Patient is Ingratiating",
                                "Patient is Uncooperative",
                                "Patient is Suspicious",
                            ],
                        }).map(([field, options]) => {
                            const currentValue = formData.behaviouralInfo.generalAppearanceAndBehaviour[field] || "";
                            const isCustomValue = currentValue && !options.includes(currentValue);

                            return (
                                <div key={field} style={{ marginBottom: "1rem" }}>
                                    <label>
                                        {field}
                                        <select
                                            value={isCustomValue ? "custom" : currentValue}
                                            onChange={(e) => {
                                                if (e.target.value === "custom") {
                                                    handleBehaviouralDropdown(
                                                        "generalAppearanceAndBehaviour",
                                                        field,
                                                        ""
                                                    );
                                                } else {
                                                    handleBehaviouralDropdown(
                                                        "generalAppearanceAndBehaviour",
                                                        field,
                                                        e.target.value
                                                    );
                                                }
                                            }}
                                            style={{ marginLeft: "1rem" }}
                                        >
                                            <option value="">Select...</option>
                                            {options.map((option) => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                            <option value="custom">Custom...</option>
                                        </select>
                                        {(isCustomValue || currentValue === "" || !options.includes(currentValue)) && (
                                            <input
                                                type="text"
                                                value={currentValue}
                                                onChange={(e) =>
                                                    handleBehaviouralDropdown(
                                                        "generalAppearanceAndBehaviour",
                                                        field,
                                                        e.target.value
                                                    )
                                                }
                                                placeholder="Custom input"
                                                style={{
                                                    width: "300px",
                                                    padding: "4px",
                                                    margin: "5px",
                                                }}
                                            />
                                        )}
                                    </label>
                                </div>
                            );
                        })}

                        <div style={styles.categorySection}>
                            <h5>Psychomotor Activity</h5>
                            {[
                                "Normal Psychomotor Activity",
                                "Agitated Psychomotor Activity",
                                "Retarded Psychomotor Activity",
                                "Increased Psychomotor Activity",
                                "Decrease Psychomotor Activity",
                            ].map((option, index) => (
                                <div key={index} style={styles.radioContainer}>
                                    <input
                                        type="radio"
                                        id={`psychomotor-${option}`}
                                        name="psychomotorActivity"
                                        value={option}
                                        checked={
                                            formData.behaviouralInfo
                                                .motorBehaviour
                                                .psychomotorActivity === option
                                        }
                                        onChange={(e) =>
                                            handlePsychomotorActivityChange(
                                                e.target.value
                                            )
                                        }
                                        style={styles.radio}
                                    />
                                    <label
                                        htmlFor={`psychomotor-${option}`}
                                        style={styles.labels}
                                    >
                                        {option}
                                    </label>
                                </div>
                            ))}
                        </div>

                        {/* Disturbances */}
                        <div style={styles.categorySection}>
                            <h5>Disturbances</h5>
                            {[
                                "Normal",
                                "Tics",
                                "Mannerisms",
                                "Stereotypes",
                                "Restlessness",
                                "Twitches",
                                "Echopraxia",
                                "Waxy Flexibility",
                                "Silly Smiling",
                                "Preseveration",
                                "Stupor",
                                "grimaces",
                            ].map((option, index) => (
                                <div
                                    key={index}
                                    style={styles.checkboxContainer}
                                >
                                    <input
                                        type="checkbox"
                                        id={`disturbance-${option}`}
                                        value={option}
                                        checked={formData.behaviouralInfo.motorBehaviour.disturbances.includes(
                                            option
                                        )}
                                        onChange={(e) =>
                                            handleDisturbancesChange(
                                                e.target.value
                                            )
                                        }
                                        style={styles.checkbox}
                                    />
                                    <label
                                        htmlFor={`disturbance-${option}`}
                                        style={styles.labels}
                                    >
                                        {option}
                                    </label>
                                </div>
                            ))}
                        </div>

                        <h4>Speech</h4>
                        {[
                            {
                                label: "Intensity",
                                options: [
                                    "Audible speech intensity",
                                    "Loud speech intensity",
                                    "Soft speech intensity",
                                    "InAudible speech intensity",
                                ],
                                key: "intensity",
                            },
                            {
                                label: "Reaction Time",
                                options: [
                                    "Normal Reaction Time",
                                    "Shortened Reaction Time",
                                    "Delayed Reaction Time",
                                ],
                                key: "reactionTime",
                            },
                            {
                                label: "Speed",
                                options: [
                                    "Normal speed",
                                    "Very Slow speed",
                                    "Rapid speed",
                                    "Pressure Of Speech speed",
                                ],
                                key: "speed",
                            },
                            {
                                label: "Ease",
                                options: [
                                    "Spontaneous",
                                    "Hesitant",
                                    "Mute",
                                    "Slurring",
                                    "Sluttering",
                                    "Whispering",
                                    "Muttering",
                                    "Speaks Only When Questioned",
                                ],
                                key: "ease",
                            },
                            {
                                label: "Relevance",
                                options: ["Relevant", "Irrelevant"],
                                key: "relevance",
                            },
                            {
                                label: "Coherant",
                                options: ["Coherant", "Incoherant"],
                                key: "coherant",
                            },
                            {
                                label: "Goal Directed",
                                options: [
                                    "Goal-Directed",
                                    "Circumstantial",
                                    "Tangential",
                                ],
                                key: "goalDirected",
                            },
                            {
                                label: "Deviation",
                                options: [
                                    "Rhyming",
                                    "Talking Past The Point",
                                    "Clang Associations",
                                    "Stereotype",
                                    "Preseveration",
                                    "NAD",
                                ],
                                key: "deviation",
                            },
                        ].map((item, index) => (
                            <div key={index} style={styles.dropdownContainer}>
                                <label style={styles.labels}>
                                    {item.label}
                                </label>
                                <select
                                    value={
                                        formData.behaviouralInfo.speech[
                                            item.key
                                        ]
                                    }
                                    onChange={(e) =>
                                        handleBehaviouralDropdown(
                                            "speech",
                                            item.key,
                                            e.target.value
                                        )
                                    }
                                    style={styles.dropdown}
                                >
                                    <option value="">Select...</option>
                                    {item.options.map((option, idx) => (
                                        <option key={idx} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ))}

                        <label style={styles.label}>
                            <p style={{ fontSize: "16px" }}>Mood and Affect </p>
                            <select
                                name="mood"
                                style={styles.dropdown}
                                value={formData.mood || ""}
                                onChange={handleChange}
                            >
                                <option value="">Select a mood</option>
                                {[
                                    "Anxious",
                                    "Depressed",
                                    "Dysthymic",
                                    "Sad",
                                    "Dysphoric",
                                    "Euthymic",
                                    "Irritable",
                                    "Cheerful",
                                    "Euphoric",
                                    "Elated",
                                    "Nil contributory",
                                ].map((mood, index) => (
                                    <option key={index} value={mood}>
                                        {mood}
                                    </option>
                                ))}
                            </select>
                        </label>

                        <input
                            type="text"
                            placeholder={"additional info"}
                            name="moodInput"
                            value={formData.moodInput}
                            onChange={handleChange}
                            style={styles.input}
                        />

                        {/* Judgement Section */}

                        {/* Thought Section */}
                        <h3 style={{ marginTop: "15px" }}>Thought</h3>
                        {[
                            {
                                label: "Stream",
                                options: [
                                    "Normal",
                                    "Flight Of Ideas",
                                    "Prolixity",
                                    "Retardation",
                                    "Preseveration",
                                    "Nil contributory",
                                ],
                                key: "stream",
                            },
                            {
                                label: "Form",
                                options: [
                                    "Loosening Of Associations",
                                    "Illogical Thinking",
                                    "Derailment",
                                    "Desultory",
                                    "Drivelling",
                                    "Neologism",
                                    "Word-Salad",
                                    "Overinclusion",
                                    "Condensation",
                                    "Circumstantiality",
                                    "Tangentiality",
                                    "Poverty Of Thought",
                                    "Nil contributory",
                                ],
                                key: "form",
                            },
                            {
                                label: "Possession",
                                options: [
                                    "Obsession",
                                    "Thought Broadcasting",
                                    "Thought Insertion",
                                    "Thought Withdrawal",
                                    "Nil contributory",
                                ],
                                key: "possession",
                            },
                            {
                                label: "Content",
                                options: [
                                    "Normal",
                                    "Preoccupations ",
                                    "Phobias/Obsessions",
                                    "Depressive Thoughts",
                                    "Delusions",
                                    "Nil contributory",
                                ],
                                key: "content",
                            },
                            {
                                label: "Perceptual",
                                options: [
                                    "Absent",
                                    "Auditory Hallucination",
                                    "Visual Hallucination",
                                    "Olfactory Hallucination",
                                    "gustatory Hallucination",
                                    "Tactile Hallucination",
                                    "Kinesthatic Hallucination",
                                ],
                                key: "perceptual",
                            },
                        ].map((item, index) => (
                            <div key={index} style={styles.dropdownContainer}>
                                <label style={styles.labels}>
                                    {item.label}
                                </label>
                                {item.options.map((option, idx) => (
                                    <div
                                        key={idx}
                                        style={styles.checkboxContainer}
                                    >
                                        <label style={{ cursor: "pointer d" }}>
                                            <input
                                                type="checkbox"
                                                value={option}
                                                checked={formData.behaviouralInfo.thought[
                                                    item.key
                                                ].includes(option)}
                                                onChange={(e) =>
                                                    handleThoughtChange(
                                                        item.key,
                                                        option,
                                                        e.target.checked
                                                    )
                                                }
                                                style={styles.checkbox}
                                            />
                                            {option}
                                        </label>
                                    </div>
                                ))}
                                <input
                                    type="text"
                                    placeholder={`Details about ${item.label}`}
                                    value={
                                        formData.behaviouralInfo
                                            .thoughtDetails?.[item.key] || ""
                                    }
                                    onChange={(e) =>
                                        handleThoughtDetailsChange(
                                            item.key,
                                            e.target.value
                                        )
                                    }
                                    style={{
                                        width: "300px",
                                        padding: "4px",
                                        marginTop: "5px",
                                        marginLeft: "1rem",
                                    }}
                                />
                            </div>
                        ))}
                    </fieldset>

                    <fieldset
                        style={{
                            border: "1px solid #ccc",
                            padding: "1rem",
                            margin: "1rem 0",
                        }}
                    >
                        <legend>Cognitive Functions </legend>
                        <h5>Level of Consciousness</h5>
                        <div style={styles.categorySection}>
                            <select
                                value={
                                    formData.behaviouralInfo
                                        .levelOfConsciousness.mediate
                                }
                                onChange={(e) =>
                                    handleBehavouralInfoChange(
                                        "levelOfConsciousness",
                                        "mediate",
                                        e.target.value
                                    )
                                }
                                style={styles.dropdown}
                            >
                                <option value="">Select...</option>
                                {[
                                    "Alert",
                                    "Lethargic/Somnolent",
                                    "Obtundation",
                                    "Stupor/Semi Coma",
                                    "Coma",
                                ].map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="my-4">
                            <h5>Orientation</h5>
                        </div>
                        {Object.entries({
                            time: [
                                "oriented towards time",
                                "partially oriented toward time",
                                "disoriented towards time",
                            ],
                            place: [
                                "oriented towards place",
                                "partially oriented toward place",
                                "disoriented towards place",
                            ],
                            person: [
                                "oriented towards person",
                                "partially oriented toward person",
                                "disoriented towards person",
                            ],
                            senseOfPassageOfTime: [
                                "Has oriented sense of passage of time",
                                "Has partially oriented sense of passage of time",
                                "does not have oriented sense of passage of time",
                            ],
                        }).map(([field, fieldOptions]) => (
                            <div key={field} style={{ marginBottom: "1rem" }}>
                                <label>
                                    {field.replace(/([A-Z])/g, " $1")}{" "}
                                    {/* Adds spaces before capital letters */}
                                    <select
                                        value={
                                            formData.behaviouralInfo
                                                .orientation[field]
                                        }
                                        onChange={(e) =>
                                            handleBehaviouralDropdown(
                                                "orientation",
                                                field,
                                                e.target.value
                                            )
                                        }
                                        style={{ marginLeft: "1rem" }}
                                    >
                                        <option value="">Select...</option>
                                        {fieldOptions.map((option) => (
                                            <option key={option} value={option}>
                                                {option}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        ))}

                        <div style={styles.categorySection}>
                            <h5>Attention and Concentration</h5>
                            <select
                                className="mb-3"
                                value={
                                    formData.behaviouralInfo
                                        .levelOfConsciousness.attention
                                }
                                onChange={(e) =>
                                    handleBehavouralInfoChange(
                                        "levelOfConsciousness",
                                        "attention",
                                        e.target.value
                                    )
                                }
                                style={styles.dropdown}
                            >
                                <option value="">Select...</option>
                                {[
                                    "Easily Aroused and sustained",
                                    "Easily aroused but not sustained",
                                    "Difficult to arouse and sustained",
                                    "Difficult to arouse and not sustained",
                                    "Coma Mediate",
                                ].map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <h4>Memory</h4>
                        {[
                            {
                                label: "Immediate",
                                options: [
                                    "Impaired Immediate Memory",
                                    "Partial Immediate Memory",
                                    "Intact Immediate Memory",
                                ],
                                key: "immediate",
                            },
                            {
                                label: "Recent",
                                options: [
                                    "Impaired Recent Memory",
                                    "Partial Recent Memory",
                                    "Intact Recent Memory",
                                ],
                                key: "recent",
                            },
                            {
                                label: "Remote",
                                options: [
                                    "Impaired Remote Memory",
                                    "Partial Remote Memory",
                                    "Intact Remote Memory",
                                ],
                                key: "remote",
                            },
                        ].map((item, index) => (
                            <div key={index} style={styles.dropdownContainer}>
                                <label style={styles.labels}>
                                    {item.label}
                                </label>
                                <select
                                    value={
                                        formData.behaviouralInfo.memory[
                                            item.key
                                        ]
                                    }
                                    onChange={(e) =>
                                        handleBehaviouralDropdown(
                                            "memory",
                                            item.key,
                                            e.target.value
                                        )
                                    }
                                    style={styles.dropdown}
                                >
                                    <option value="">Select...</option>
                                    {item.options.map((option, idx) => (
                                        <option key={idx} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ))}
                        {/* Intelligences Section */}
                        <h4>Intelligences</h4>
                        {[
                            {
                                label: "Fund Of Information",
                                options: [
                                    "Above Average",
                                    "Average",
                                    "Sub Average",
                                    "not elicited",
                                ],
                                key: "fundOfInformation",
                            },
                            {
                                label: "Calculations",
                                options: [
                                    "appropriate",
                                    "impaired",
                                    "not elicited",
                                ],
                                key: "calculations",
                            },
                            {
                                label: "Abstract Thinking",
                                options: [
                                    "impaired",
                                    "poor",
                                    "intact",
                                    "concrete thinking",
                                ],
                                key: "abstractReasoning",
                            },
                        ].map((item, index) => {
                            const currentValue = formData.behaviouralInfo.intelligences[item.key] || "";
                            const isCustomValue = currentValue && !item.options.includes(currentValue);

                            return (
                                <div key={index} style={styles.dropdownContainer}>
                                    <label style={styles.labels}>
                                        {item.label}
                                    </label>
                                    <div style={{ display: "flex", gap: "4px" }}>
                                        {/* Dropdown for preset options */}
                                        <select
                                            value={isCustomValue ? "custom" : currentValue}
                                            onChange={(e) => {
                                                if (e.target.value === "custom") {
                                                    handleBehaviouralDropdown(
                                                        "intelligences",
                                                        item.key,
                                                        ""
                                                    );
                                                } else {
                                                    handleBehaviouralDropdown(
                                                        "intelligences",
                                                        item.key,
                                                        e.target.value
                                                    );
                                                }
                                            }}
                                            style={styles.dropdown}
                                        >
                                            <option value="">Select...</option>
                                            {item.options.map((option, idx) => (
                                                <option key={idx} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                            <option value="custom">Custom...</option>
                                        </select>

                                        {/* Input field for entering custom value - only shown when needed */}
                                        {(isCustomValue || currentValue === "" || !item.options.includes(currentValue)) && (
                                            <input
                                                type="text"
                                                value={currentValue}
                                                onChange={(e) =>
                                                    handleBehaviouralDropdown(
                                                        "intelligences",
                                                        item.key,
                                                        e.target.value
                                                    )
                                                }
                                                placeholder="Enter custom value"
                                                style={styles.input}
                                            />
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                        <h4>Judgement</h4>
                        {[
                            { label: "Social", key: "social", options: ["Impaired", "Intact", "Poor"] },
                            { label: "Personal", key: "personal", options: ["Impaired", "Intact", "Poor"] },
                            { label: "Test", key: "test", options: ["Impaired", "Intact", "Poor"] },
                        ].map((item, index) => {
                            const currentValue = formData.behaviouralInfo.judgement[item.key] || "";
                            const isCustomValue = currentValue && !item.options.includes(currentValue);

                            return (
                                <div key={index} style={styles.dropdownContainer}>
                                    <label style={styles.labels}>
                                        {item.label}
                                    </label>

                                    {/* Dropdown to choose preset options */}
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <select
                                            value={isCustomValue ? "custom" : currentValue}
                                            onChange={(e) => {
                                                if (e.target.value === "custom") {
                                                    handleBehaviouralDropdown(
                                                        "judgement",
                                                        item.key,
                                                        ""
                                                    );
                                                } else {
                                                    handleBehaviouralDropdown(
                                                        "judgement",
                                                        item.key,
                                                        e.target.value
                                                    );
                                                }
                                            }}
                                            style={styles.dropdown}
                                        >
                                            <option value="">Select...</option>
                                            <option value="Impaired">
                                                Impaired
                                            </option>
                                            <option value="Intact">Intact</option>
                                            <option value="Poor">Poor</option>
                                            <option value="custom">Custom...</option>
                                        </select>

                                        {/* Input field that shows current value and allows custom input - only shown when needed */}
                                        {(isCustomValue || currentValue === "" || !item.options.includes(currentValue)) && (
                                            <input
                                                type="text"
                                                value={currentValue}
                                                onChange={(e) =>
                                                    handleBehaviouralDropdown(
                                                        "judgement",
                                                        item.key,
                                                        e.target.value
                                                    )
                                                }
                                                placeholder="Enter custom value"
                                                style={styles.input}
                                            />
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </fieldset>
                    <h5 style={{ marginTop: "5px" }}>Insight</h5>
                    <div style={styles.categorySection}>
                        <select
                            value={formData.behaviouralInfo.insight}
                            onChange={(e) =>
                                handleBehavouralInfoChange(
                                    "",
                                    "insight",
                                    e.target.value
                                )
                            }
                            style={styles.dropdown}
                        >
                            <option value="">Select...</option>
                            {[
                                "poor",
                                "intact",
                                "fair",
                                "grade 1",
                                "grade 2",
                                "grade 3",
                                "grade 4",
                                "grade 5",
                                "grade 6",
                            ].map((option, index) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>

                    <label style={styles.label}>
                        Tools Used:{" "}
                        <select
                            style={styles.dropdown} // Replace with appropriate styles
                            onChange={(e) => {
                                if (e.target.value === "HAM-A") {
                                    window.open(
                                        `/HamiltonForm/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "HAM-D") {
                                    window.open(
                                        `/hamd/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "CDRS") {
                                    window.open(
                                        `/cdrs/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "YMRS") {
                                    window.open(
                                        `/YMRS/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "YBOCS") {
                                    window.open(
                                        `/ybocs/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "PANSS") {
                                    window.open(
                                        `/panss/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "BDI") {
                                    window.open(
                                        `/bdi/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "CYBCOS") {
                                    window.open(
                                        `/cybcos/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "ISAA") {
                                    window.open(
                                        `/isaa/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (e.target.value === "Psychiatric Rating") {
                                    window.open(
                                        `/psychiatric/${appointment?._id}`,
                                        "_blank",
                                        "rel=noopener noreferrer"
                                    );
                                }
                                if (
                                    e.target.value === "Rorschach Ink Blot Test"
                                ) {
                                    console.log("Rorschach selected", blotTest);
                                    console.log("formData", formData);
                                    setFormData((prev) => ({
                                        ...prev,
                                        blotTest:
                                            prev.blotTest === "1" ? "" : "1", // ✅ toggle directly
                                    }));
                                }
                                e.target.value = "";
                            }}
                        >
                            <option value="" disabled selected>
                                Select Form
                            </option>
                            <option value="HAM-A">
                                Hamilton Anxiety Rating Scale (HAM-A)
                            </option>
                            <option value="HAM-D">
                                Hamilton Depession Rating Scale (HAM-D)
                            </option>
                            <option value="CDRS">
                                Children's Depression Rating Scale (CDRS)
                            </option>
                            <option value="YBOCS">
                                YALE-BROWN OBSESSIVE COMPULSIVE SCALE(YBOCS)
                            </option>
                            <option value="YMRS">
                                Young Mania Rating Scale(YMRS)
                            </option>
                            <option value="PANSS">
                                POSITIVE AND NEGATIVE SYNDROME SCALE(PANSS)
                            </option>
                            <option value="BDI">
                                Beck's Depression Inventory(BDI-II)
                            </option>
                            <option value="CYBCOS">
                                Children’s Yale-Brown Obsessive Compulsive Scale
                            </option>
                            <option value="ISAA">
                                Indian Scale for Assessment of Autism (ISAA)
                            </option>
                            <option value="Psychiatric Rating">
                                Brief Psychiatric Rating Scale
                            </option>
                            <option value="Rorschach Ink Blot Test">
                                Rorschach Ink Blot Test
                            </option>
                        </select>
                        {toolsOptions.map((tool, index) => (
                            <div
                                key={index}
                                style={{
                                    padding: '8px',
                                    margin: '5px 0',
                                    backgroundColor: '#f0f0f0',
                                    borderRadius: '5px'
                                }}
                            >
                                {tool.tool} Score : {tool.score}
                            </div>
                        ))}
                    </label>

                    <label style={styles.label}>
                        Test Finding:
                        <input
                            type="text"
                            placeholder={"Test Finding"}
                            name="testFinding"
                            value={formData.testFinding}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </label>

                    <label style={styles.label}>
                        Interpretations:
                        <textarea
                            name="interpretations"
                            style={styles.textarea}
                            rows="5"
                            value={`${formData.interpretations}`}
                            onChange={handleChange}
                        ></textarea>
                    </label>

                    <label style={styles.label}>
                        Suggestions:
                        <div style={styles.checkboxContainer}>
                            {suggestionsList.map((suggestion, index) => (
                                <div key={index} style={styles.checkboxWrapper}>
                                    <label style={{ cursor: "pointer" }}>
                                        <input
                                            type="checkbox"
                                            name="suggestions"
                                            value={suggestion}
                                            checked={formData.suggestions.includes(
                                                suggestion
                                            )}
                                            onChange={handleSugestion}
                                        />
                                        {suggestion}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </label>

                    <button type="submit" style={styles.submitButton}>
                        Submit
                    </button>
                </form>
            </>
        </Layout>
    );
};

const styles = {
    form: {
        display: "grid",
        gap: "10px", // Increased gap for better spacing
        maxWidth: "1000px",
        margin: "100px auto",
        padding: "25px",
        borderRadius: "8px",
        fontSize: "18px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f9f9f9",
    },
    optionContainer: {
        marginBottom: "15px",
    },
    label: {
        display: "block",
        marginBottom: "6px",
        fontWeight: "600",
        fontSize: "12px",
        color: "#333",
        paddingLeft: "5px",
    },
    dropdown: {
        width: "100%",
        padding: "8px 10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        marginBottom: "10px",
    },
    subOptionContainer: {
        paddingLeft: "20px", // Indent sub-options
        marginBottom: "10px",
    },
    subLabel: {
        display: "block",
        marginBottom: "6px",
        fontSize: "14px",
        fontWeight: "500",
        color: "#555",
        paddingLeft: "10px",
    },
    formHeader: {
        fontSize: "20px", // Slightly larger font size
        fontWeight: "bold",
        marginBottom: "15px",
        textAlign: "center",
    },
    label: {
        fontSize: "16px",
        fontWeight: "600",
        marginBottom: "5px",
        color: "#333",
    },
    labels: {
        fontSize: "16px",
        fontWeight: "600",
        marginBottom: "5px",
        color: "#333",
        cursor: "pointer",
    },
    input: {
        width: "100%",
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
    },
    select: {
        width: "100%",
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
    },
    textarea: {
        width: "100%",
        // marginTop: "10px",
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "16px",
        resize: "vertical",
    },
    dropdownContainer: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "10px",
        // gap: "10px",
        paddingLeft: "10px", // Indent for subcategories
    },
    subDropdownContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        paddingLeft: "20px", // Further indent for sub-subcategories
    },
    dropdownLabel: {
        fontSize: "15px",
        fontWeight: "500",
        color: "#444",
    },
    // dropdown: {
    //   marginTop: "5px",
    //   padding: "8px",
    //   borderRadius: "5px",
    //   border: "1px solid #ccc",
    //   fontSize: "15px",
    //   cursor: "pointer",
    //   backgroundColor: "#fff",
    // },
    addButton: {
        padding: "8px 16px",
        backgroundColor: "#007BFF",
        color: "#FFFFFF",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "14px",
    },
    submitButton: {
        padding: "10px 20px",
        backgroundColor: "#28a745",
        color: "#FFFFFF",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    viewButton: {
        padding: "10px 20px",
        backgroundColor: "#28a745",
        margin: "20px",
        color: "#FFFFFF",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    deleteButton: {
        padding: "8px 12px",
        backgroundColor: "#dc3545", // Red color for delete button
        color: "#FFFFFF",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        margin: "10px",
    },
    categorySection: {
        marginBottom: "20px",
    },
};
export default Psychodiagnostic;
